import React, { useState, useEffect, Suspense, useRef } from "react";
import Header from "../Header";
import { useLocation } from "react-router-dom";
import Banner from "../../assets/career/career-people.svg";
import "./career.css";
import Footer from "../Footer";
import { data } from "./careerObj";
import { motion, AnimatePresence } from "framer-motion";
import { CONSTANTS } from "../../helpers/Constant";
import Logo from "../../assets/logo.svg";
import Close from "../Icons/Close";
import JobModal from "./Modal";
import { SuspenseImg } from "../../helpers/SuspenseImg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ContactFrom from "../ContactFrom/index";

const Career = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [modalData, setModalData] = useState();
  const [selectedJobTitle, setSelectedJobTitle] = React.useState("");
  const [showModalLayout, setShowModalLayout] = useState(false);

  const sendDataToParent = (value) => {
    setSelectedJobTitle(value);
  };

  const openModalLayout = (selectedJob) => {
    setShowModalLayout(true);

    setModalData(selectedJob);
  };

  const closeModalLayout = () => {
    setShowModalLayout(false);
  };

  const renderJobList = (rowNo) => {

    return data.filter(item => item.row === rowNo).map((item) => (
      <div
        className="bg-white rounded-lg shadow-lg p-6 current-opening cursor-pointer"
        key={item.id}
        onClick={() => openModalLayout(item)}
      >
        <h5 className="md:text-sm text-lg font-avenirHeavy text-blue-800">
          {item.title}
        </h5>
        <p className="md:text-13 text-base font-normal font-opensans text-Gray-400 py-3">
          {item.description}
        </p>
        <span className="md:text-13 text-base font-normal text-Gray-400">
          <span className="font-semibold">{item.experience}+</span> years
          experience
        </span>
      </div>
    ));
  }

  const formRef = useRef(null);

  return (
    <>
      <Header />
      <section className="md:mt-16 md:mt-8 mt-14">
        <div className="bg-Gray-50 md:py-16 pt-8 pb-4">
          <div className="mid-container">
            <div className="container sm:container md:container lg:container w-full mx-auto">
              <div className="flex flex-col md:flex-row items-center justify-center md:justify-between">
                <div className="md:w-3/5 w-full">
                  <h2 className="md:text-5xl text-3xl leading-tight font-avenirHeavy text-Gray-900 mobile-text">
                    Are you an{" "}
                    <span className="text-pink-500"> enthusiastic</span>{" "}
                    <span className="inline md:block">
                      <span className="text-pink-300">tech savvy</span>{" "}
                      individual?
                    </span>
                  </h2>
                  <div className="md:hidden block">
                    <Suspense fallback="Loading...">
                      <SuspenseImg alt="" className="mx-auto" src={Banner} />
                    </Suspense>
                  </div>

                  <p className="font-avenirBook text-lg md:text-xl text-Gray-600 md:py-4 py-6">
                    Join us, let's make a great difference
                  </p>
                </div>

                <div className="md:block hidden md:w-2/5	w-full">
                  <Suspense fallback="Loading...">
                    <SuspenseImg alt="" src={Banner} className="w-full" />
                  </Suspense>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="md:py-24 py-12 bg-Gray-250">
        <div className="mid-container">
          <div className="container sm:container md:container lg:container w-full mx-auto">
            <h1 className="text-Gray-900 text-3xl font-avenirHeavy md:text-4xl">
              Current openings
            </h1>
            <div className="flex flex-row items-center md:pt-10 pt-5">
              <div className="grid md:grid-cols-2 grid-cols-1 md:w-4/4 md:gap-4 gap-8 w-full">
                {renderJobList(1)}
              </div>
            </div>
            <div className="flex flex-row items-center md:pt-10 pt-5">
              <div className="grid md:grid-cols-2 grid-cols-1 md:w-4/4 md:gap-4 gap-8 w-full">
                {renderJobList(2)}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="md:pt-24 pt-12 pb-12 why-we-care relative">
        <div className="mid-container">
          <div className="container sm:container md:container lg:container w-full mx-auto">
            <div className="flex flex-col md:flex-row  justify-center md:justify-between">
              <div className="w-full md:w-6/12">
                <h3 className="text-blue-800 text-3xl md:text-5xl font-avenirHeavy">
                  We care
                </h3>
                <p
                  className="text-blue-800 font-opensans font-normal text-base md:text-2xl leading-relaxed py-8"
                  style={{ lineHeight: "2.3rem" }}
                >
                  Rather than profit optimization we care about the value we
                  provide. We care about the well-being of our employees and
                  their career development.
                </p>
                <p className="text-Gray-600 text-sm font-opensans font-normal leading-relaxed">
                  We house a variety of consulting profiles, mainly developers,
                  data scientists, UX designers and business analysts. IT
                  consultants play a vital role by acting strategically as
                  multi-faced and dynamic hands-on specialists to resolve client
                  issues.
                </p>
              </div>
              <div className="w-full md:w-3/6 lg:w-2/6 relative ">
                <span className="polygon absolute -right-6 top-2"></span>
                <span className="oval absolute top-32 rounded-full -left-10"></span>
                {/* <img
                  src={}
                  alt=""
                  className="absolute z-10 -top-4 -right-10"
                /> */}
                <h3 className="text-lg mt-8 md:mt-0 pb-5 font-avenirBook md:font-medium font-semibold">
                  Perks and Benefits
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-2 gap-6 grid-rows-2 md:grid-rows-2 relative z-50 w-full ">
                  <div className="bg-white rounded-xl shadow-xl md:py-10 py-10 lg:px-10 px-3 flex flex-col justify-center text-center border border-Gray-150">
                    <span className="font-avenirBook text-Gray-900 text-base">
                      Medical insurance
                    </span>
                  </div>
                  <div className="bg-white rounded-xl shadow-xl md:py-10 py-10 lg:px-10 px-3 flex flex-col justify-center text-center border border-Gray-150">
                    <span className="font-avenirBook text-Gray-900 text-base">
                      Flexible leave policy
                    </span>
                  </div>
                  <div className="bg-white rounded-xl shadow-xl md:py-10 py-10 lg:px-10 px-3 flex flex-col justify-center text-center border border-Gray-150">
                    <span className="font-avenirBook text-Gray-900 text-base">
                      Computer allowance
                    </span>
                  </div>
                  <div className="bg-white rounded-xl shadow-xl md:py-10 py-10 lg:px-10 px-3 flex flex-col justify-center text-center border border-Gray-150">
                    <span className="font-avenirBook text-Gray-900 text-base">
                      Communication allowance
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="md:pt-12 pt-6 md:pb-24 pb-12 skill-set-view">
        <div className="mid-container">
          <div className="container sm:container md:container lg:container w-full mx-auto">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-8  relative z-50 w-full">
              <div className="">
                <h3 className="text-Gray-900 text-xl md:text-3xl font-semibold font-avenirBook">
                  What we are looking for
                </h3>
                <ul className="font-opensans text-sm text-Gray-600 pt-3">
                  <li>
                    Work collaboratively as part of a creative team that
                    includes both clients and internal colleagues{" "}
                  </li>
                  <li>Meeting with clients to gather requirements. </li>
                  <li>
                    Offer recommended hardware, software, web and networking
                    solutions to clients.{" "}
                  </li>
                  <li>
                    Facilitate brainstorming sessions with clients and internal
                    project teams.{" "}
                  </li>
                  <li>
                    Provide strategic guidance to the clients in terms of
                    Information Technology.
                  </li>
                </ul>
              </div>
              <div className="">
                <h3 className="text-Gray-900 text-xl md:text-3xl font-semibold font-avenirBook">
                  Requirements and Skills
                </h3>
                <ul className="font-opensans text-sm text-Gray-600 pt-3">
                  <li>
                    Working experience in IT supporting diverse platforms to
                    systems.
                  </li>
                  <li>
                    Up to date knowledge of emerging software, platforms and
                    technologies.
                  </li>
                  <li>Excellent communication and presentation skill</li>
                  <li>Strong troubleshooting skills in IT systems.</li>
                  <li>
                    Logical approach to problem solving and analytic skills.
                  </li>
                  <li>
                    Ability to communicate technical information to non IT
                    clients.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="md:py-24 py-12 career-inter-view md:px-0 px-6">
        <div className="bg-black bg-opacity-25 py-8 md:px-10 px-6 md:max-w-screen-sm max-w-full	mx-auto md:mx-auto mx-3">
          <h2 className="text-white font-avenirHeavy text-xl md:text-3xl">
            Internship and degree project
          </h2>
          <p className="md:text-lg text-base text-white py-5 font-opensans font-medium">
            We believe in passing down our insights to young, driven students
            and graduates.
          </p>
          <p className="md:text-sm text-xs text-white font-opensans font-light">
            Through our internship programs. we give interns and graduates a
            feel of what to expect when they rare in the industry.
          </p>
        </div>
      </section>
      <section className="md:py-24 py-12 bg-Gray-50" ref={formRef}>
        <div className="container sm:container md:container lg:container w-full mx-auto">
          <div className="md:w-9/12 w-full mx-auto">
            <div className="flex flex-col md:flex-row md:justify-between">
              <div className="md:w-2/5	w-full join-us-view md:pt-24 pt-0 md:pl-6 p-0 z-50">
                <h2 className="text-Gray-900 text-3xl md:text-4xl font-avenirHeavy">
                  Interested in{" "}
                  <span className="inline-block md:block">
                    working with us?
                  </span>
                </h2>
                <p className="text-lg text-blue-800 font-opensans font-normal pt-4 md:pt-20 leading-relaxed">
                  Well, register your resume in our CV database, and we will
                  notify you when there is an opening that matches your
                  expertise.{" "}
                </p>
                <p className="text-sm font-opensans text-Gray-600 font-normal pt-5">
                  You can also monitor the vacancies that are posted to find the
                  position that suits you.
                </p>
              </div>
              <div className="md:w-7/12	w-full md:pl-10 p-0 pt-6 md:pt-0">
                <h3 className="font-avenirBook text-xl md:text-3xl pt-3 text-blue-800">
                  Register with us
                </h3>
                <ContactFrom
                  className="career-form"
                  selectedJobTitle={selectedJobTitle}
                  key={selectedJobTitle}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {showModalLayout && (
        <AnimatePresence exitBeforeEnter>
          <motion.div
            className="backdrop"
            variants={CONSTANTS.MODAL_BACK_DROP}
            initial="hidden"
            animate="visible"
          >
            <motion.div
              className="w-full "
              variants={CONSTANTS.MODAL_ANIMATE}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <div className=" max-w-full relative">
                <div className="mid-container">
                  <div className="container sm:container md:container lg:container w-full mx-auto">
                    <div className="py-10">
                      <div className="flex flex-row justify-between">
                        <img src={Logo} alt="" title="" />
                        <Close
                          className="cursor-pointer"
                          onClick={closeModalLayout}
                        />
                      </div>
                    </div>
                    <JobModal
                      modalData={modalData}
                      closeModalLayout={closeModalLayout}
                      formRef={formRef}
                      sendDataToParent={sendDataToParent}
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>
      )}
    </>
  );
};

export default Career;
